var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29.5V28.15H16V19.9C16 18.4833 16.4542 17.225 17.3625 16.125C18.2708 15.025 19.4167 14.325 20.8 14.025V13.725C20.8 13.3917 20.9167 13.1083 21.15 12.875C21.3833 12.6417 21.6667 12.525 22 12.525C22.3333 12.525 22.6167 12.6417 22.85 12.875C23.0833 13.1083 23.2 13.3917 23.2 13.725V14.025C24.5833 14.325 25.7333 15.0192 26.65 16.1075C27.5667 17.1958 28.025 18.46 28.025 19.9V28.15H29.525V29.5H14.5ZM21.9948 32.3C21.4983 32.3 21.075 32.1237 20.725 31.7712C20.375 31.4187 20.2 30.995 20.2 30.5H23.8C23.8 31 23.6233 31.425 23.2697 31.775C22.9162 32.125 22.4913 32.3 21.9948 32.3ZM17.35 28.15H26.675V19.9C26.675 18.6 26.2202 17.5 25.3105 16.6C24.4008 15.7 23.2967 15.25 21.998 15.25C20.6993 15.25 19.6 15.7 18.7 16.6C17.8 17.5 17.35 18.6 17.35 19.9V28.15Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon);
export default __webpack_public_path__ + "static/media/bellicon.d96e0269f61f657f8a8ed0b3d38c4a01.svg";
export { ForwardRef as ReactComponent };